import { render } from "./ApplicationFormPersonal.vue?vue&type=template&id=27bc2189&scoped=true"
import script from "./ApplicationFormPersonal.vue?vue&type=script&lang=js"
export * from "./ApplicationFormPersonal.vue?vue&type=script&lang=js"

import "./ApplicationFormPersonal.vue?vue&type=style&index=0&id=27bc2189&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bc2189"]])

export default __exports__